import JobEmployeeForm from "./index";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

const JobEmployeeFormPage = () => {
  const { jobId, employeeId } = useParams();
  const navigate = useNavigate();

  function handleSuccess() {
    navigate(-1);
  }

  return (
    <div className="p-6 max-w-xl">
      <JobEmployeeForm
        jobId={jobId}
        employeeId={employeeId}
        onSuccess={handleSuccess}
      />
    </div>
  );
};

export default JobEmployeeFormPage;
